import { api } from "../api";
import type { Agendamento } from "./agendamento";

export interface Campanha {
  id: string;
  nome: string;
  descricao: string;
  dataEvento: string;
  dataFimInscricao: string;
  vagasDisponiveis: number;
  vagasTotal: number;
  tipo: {
    id: string;
    nome: string;
    descricao: string;
  };
}

export interface CampanhaDetalhes extends Campanha {
  dataInicioInscricao: string;
  ativa: boolean;
}

export interface AgendamentoCampanha {
  petId: string;
  tipoId: string;
  observacao?: string;
  campanhaId: string;
}

export class CampanhaService {

  async getCampanhasAtivas(): Promise<Campanha[]> {
    try {
      const response = await api.get("/campanhas/ativas");
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar campanhas ativas:", error);
      throw error;
    }
  }

  async getCampanhaById(campanhaId: string): Promise<CampanhaDetalhes> {
    try {
      const response = await api.get(`/campanhas/publica/${campanhaId}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar detalhes da campanha:", error);
      throw error;
    }
  }

  async agendarParaCampanha(dados: AgendamentoCampanha): Promise<Agendamento> {
    try {
      const response = await api.post("/agendamentos", dados);
      return response.data;
    } catch (error) {
      console.error("Erro ao agendar para campanha:", error);
      throw error;
    }
  }
}
